<template>
  <div class="main container">
    <countdown class="row" :end="end"></countdown>
    <!-- <calendar class="row" :end="end"></calendar> -->
    <img class="row" src="./../assets/eri-mudkip.jpg" alt="">
  </div>

</template>

<script>
import Countdown from "./Countdown";
import Calendar from "./Calendar";
import moment from "moment";

export default {
  name: 'Main',
  components: {
    Countdown,
    Calendar
  },
  data () {
    return {
      end: moment('2018-06-06 20:00+02:00'),
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main {
  margin: 30px auto;
  max-width: 480px;
}


img {
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Main.vue